import deleteReducer from 'commonComponents/redux/reducer';
import companyAdminReducer from 'commonRedux/getCompanyAdmin/reducer';
import fluidHandlerReducer from 'commonRedux/getFluidHandler/reducer';
import companyListReducer from 'components/companyList/redux/reducer';
import dashboardReducer from 'components/dashboard/redux/reducer';
import libraryReducer from 'components/library/redux/reducer';
import authReducer from 'components/login/reducer';
import bulkUploadReducer from 'components/machineList/bulkUploadRedux/reducer';
import machineListReducer from 'components/machineList/redux/reducer';
import notificationReducer from 'components/notification/redux/reducer';
import oilListReducer from 'components/oilList/redux/reducer';
import reportReducer from 'components/report/redux/reducer';
import userListReducer from 'components/userList/redux/reducer';
import { combineReducers } from 'redux';
import { CLEAR_AUTH_TOKEN } from 'components/login/action';
import oilListByCompanyReducer from 'commonRedux/getOilByCompanyId/reducer';
import alertNotificationReducer from 'components/alertNotification/redux/reducer';
import bannerReducer from 'components/adminSettings/redux/reducer';
import monthDayReportReducer from 'components/monthDayReport/redux/reducer';

//Reducer for Redux
const appReducer = combineReducers({
  authReducer: authReducer,
  userListReducer: userListReducer,
  deleteReducer: deleteReducer,
  machineListReducer: machineListReducer,
  companyListReducer: companyListReducer,
  bulkUploadReducer: bulkUploadReducer,
  companyAdminReducer: companyAdminReducer,
  fluidHandlerReducer: fluidHandlerReducer,
  oilListReducer: oilListReducer,
  notificationReducer: notificationReducer,
  dashboardReducer: dashboardReducer,
  reportReducer: reportReducer,
  libraryReducer: libraryReducer,
  oilListByCompanyReducer: oilListByCompanyReducer,
  alertNotificationReducer: alertNotificationReducer,
  bannerReducer: bannerReducer,
  monthDayReportReducer: monthDayReportReducer

});

const rootReducer = (state, action) => {
  if (action.type === CLEAR_AUTH_TOKEN) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
